import BaseHandler from "../BaseHandler";
import { StoryGetStoriesResponse } from "../../proto/StoryGetStories_pb";
import store from "../../store";
import { setStoriesList } from "../../store/stories/actions";
import { StoryUserAddNewResponse } from "../../proto/StoryUserAddNew_pb";

export default class HandleStoryGetStoriesResponse extends BaseHandler<StoryGetStoriesResponse> {
  handle() {
    const getStoriesResponse = this.response.toObject();
    if (getStoriesResponse.groupedStoriesList) store.dispatch(setStoriesList(getStoriesResponse.groupedStoriesList));
  }
}
